import { motion } from "framer-motion";
import { FiTool, FiArrowLeft, FiSettings } from "react-icons/fi";
import { Link } from "react-router-dom";
import IconoUsuarioPlano from "../components/ui/IconoUsuarioPlano";
import ScrollToTop from "../components/ui/ScrollToTop";

const AuthMaintenance = ({ type }) => {
    const isLogin = type === "login";

    return (
        <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-6 relative overflow-hidden">
            <ScrollToTop />
            {/* Fondo decorativo de ingeniería (Grid de planos) */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
                style={{ backgroundImage: `url('https://www.transparenttextures.com/patterns/graphy.png')` }} />

            {/* Círculos de luz decorativos */}
            <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#F26B1D]/5 rounded-full blur-[120px]" />
            <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-[#1C1C1C]/5 rounded-full blur-[120px]" />

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="relative z-10 max-w-md w-full bg-white/80 backdrop-blur-xl border border-white shadow-2xl rounded-3xl p-8 md:p-12 text-center"
            >
                <div className="relative inline-flex mb-10 justify-center">
                    <IconoUsuarioPlano scale={1.2} /> {/* Escala para que se vea más grande en esta página */}
                </div>
                
                {/* Icono Animado */}
                <div className="relative inline-block mb-8">
                    <motion.div
                        animate={{ rotate: [0, 10, 0] }}
                        transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
                        className="w-20 h-20 bg-[#F26B1D] rounded-2xl flex items-center justify-center text-white shadow-lg shadow-orange-200"
                    >
                        <FiSettings size={40} className="animate-spin-slow" />
                    </motion.div>
                    {/* Icono de Herramienta corregido */}
                    <div className="absolute -bottom-2 -right-2 bg-[#1C1C1C] p-2 rounded-lg text-white">
                        <FiTool size={20} />
                    </div>
                </div>

                {/* Texto */}
                <h1 className="text-3xl font-black text-[#1C1C1C] mb-4 tracking-tighter uppercase">
                    {isLogin ? "Acceso Protegido" : "Registro de Clientes"}
                </h1>
                <p className="text-gray-500 font-medium leading-relaxed mb-8">
                    Estamos configurando nuestro <span className="text-[#F26B1D] font-bold">Portal Planix</span>.
                    Pronto podrás gestionar tus proyectos y planos desde aquí.
                </p>

                {/* Barra de Progreso Simbolizada */}
                <div className="bg-gray-100 h-2 w-full rounded-full mb-8 overflow-hidden">
                    <motion.div
                        initial={{ width: 0 }}
                        animate={{ width: "75%" }}
                        transition={{ duration: 2, ease: "easeOut" }}
                        className="h-full bg-[#F26B1D] shadow-[0_0_10px_#F26B1D]"
                    />
                </div>

                {/* Botón Volver */}
                <div className="space-y-4">
                    <Link
                        to="/"
                        className="flex items-center justify-center gap-2 w-full py-4 bg-[#1C1C1C] text-white rounded-2xl font-bold hover:bg-[#F26B1D] transition-all shadow-xl active:scale-95 group"
                    >
                        <FiArrowLeft className="group-hover:-translate-x-1 transition-transform" />
                        Volver al Inicio
                    </Link>
                    <p className="text-[10px] text-gray-400 uppercase tracking-[0.2em] font-bold">
                        Ingeniería en Desarrollo • 2026
                    </p>
                </div>
            </motion.div>
        </div>
    );
};

export default AuthMaintenance;